<div class="card">
  <div class="ui-g-12">

    <app-kontable
      title="{{ 'common.storeServices' | translate }}"
      [source]="serviceList"
      [columns]="[ 'service_id', 'service_name', 'service_description' ]"
      [titles]="[ 'common.id', 'common.name', 'common.description' ]"
      [showGlobalFilter]="false"
      [showRecoverButton]="false"
      [showAddButton]="true"
      [showInfoButton]="false"
      [showDetailsButton]="false"
      [showTotalPages]="false"
      [showTotalRecord]="false"
      [defaultRowsPerPageOptions]="null"
      [konPermissions]="perm"
      (onAdd)="showAddService()"
      (onRemove)="deleteServiceStore($event)"
      [(fireNewDataAvailable)]="newDataAvailable"
    ></app-kontable>

    <p-dialog *ngIf="showDialog"
              [width]="500"
              [(visible)]="showDialog"
              [responsive]="true"
              showEffect="fade"
              [modal]="true"
              (onHide)="onDialogHide()"
              [header]="addServiceTitle">

      <app-store-common-services-form
        (onAddElement)="onAddElement($event)"
        [storeId]="storeId"
      >
      </app-store-common-services-form>
    </p-dialog>

  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/views/administration/store/store-common-services/store-common-services.component.html